/* ============
 * Getters for the formalities module
 * ============
 *
 * The getters that are available on the
 * formalities module.
 */

export default {
  userInfo: state => { return state.user }
}



// WEBPACK FOOTER //
// ./src/store/modules/formalities/getters.js